export const msToClock = (ms: number) => {
  const safeMs = Math.max(0, Math.floor(ms || 0))
  const s = (safeMs / 1000) | 0
  const m = (s / 60) | 0
  return String(m).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0')
}

export const formatDurationCompact = (timeMs: number | null | undefined) => {
  if (timeMs == null || !Number.isFinite(timeMs)) return '—'
  const totalSeconds = Math.round(timeMs / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  if (minutes === 0) return `${seconds}s`
  return `${minutes}m${String(seconds).padStart(2, '0')}s`
}
